// action types
import { createRequestTypes } from "../../utils";

// Fetch Pending Varieties
export const FETCH_PENDING_VARIETIES = createRequestTypes("FETCH_PENDING_VARIETIES");

export const fetchPendingVarietiesRequest = () =>
    ({ type: FETCH_PENDING_VARIETIES.REQUEST });

export const fetchPendingVarietiesSuccess = (data) =>
    ({ type: FETCH_PENDING_VARIETIES.SUCCESS, payload: { data } });

export const fetchPendingVarietiesFailure = (error) =>
    ({ type: FETCH_PENDING_VARIETIES.FAILURE, payload: error });

// Approve Variety
export const APPROVE_VARIETY = createRequestTypes("APPROVE_VARIETY");

export const approveVarietyRequest = (variety_id, notes) =>
    ({ type: APPROVE_VARIETY.REQUEST, payload: { variety_id, notes } });

export const approveVarietySuccess = () =>
    ({ type: APPROVE_VARIETY.SUCCESS });

export const approveVarietyFailure = (error) =>
    ({ type: APPROVE_VARIETY.FAILURE, payload: { error } });

// Reject Variety
export const REJECT_VARIETY = createRequestTypes("REJECT_VARIETY");

export const rejectVarietyRequest = (variety_id, notes) =>
    ({ type: REJECT_VARIETY.REQUEST, payload: { variety_id, notes } });

export const rejectVarietySuccess = () =>
    ({ type: REJECT_VARIETY.SUCCESS });

export const rejectVarietyFailure = (error) =>
    ({ type: REJECT_VARIETY.FAILURE, payload: { error } });

// Promote Variety to Global
export const PROMOTE_VARIETY = createRequestTypes("PROMOTE_VARIETY");

export const promoteVarietyRequest = (variety_id, notes) =>
    ({ type: PROMOTE_VARIETY.REQUEST, payload: { variety_id, notes } });

export const promoteVarietySuccess = () =>
    ({ type: PROMOTE_VARIETY.SUCCESS });

export const promoteVarietyFailure = (error) =>
    ({ type: PROMOTE_VARIETY.FAILURE, payload: { error } });
